import React, { useState } from "react"
import { Nav, TabContent, TabPane, NavLink, Card, CardBody } from "reactstrap"
import { FormSection, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import Questions from "./questions"
import validate from "./surveyValidation"
import Responses from "./responses"
import PropTypes from "prop-types"
import MenuFeatureHyperlinks from "../menuFeatureHyperlinks"

let Survey = props => {
  const TABS = {
    QUESTIONS: 1,
    RESPONSES: 2,
    HYPERLINKS: 3,
  }
  const [activeTab, setActiveTab] = useState(TABS.QUESTIONS)
  const markAsActive = tab => {
    return activeTab === tab ? "active" : ""
  }
  return (
    <React.Fragment>
      <Card>
        <CardBody className="shadow-sm p-1">
          <Nav tabs pills>
            <NavLink
              className={markAsActive(TABS.QUESTIONS)}
              onClick={() => setActiveTab(TABS.QUESTIONS)}
            >
              Questions
            </NavLink>
            <NavLink
              className={markAsActive(TABS.RESPONSES)}
              onClick={() => setActiveTab(TABS.RESPONSES)}
            >
              Responses
            </NavLink>
            {props?.isEventFeature &&
              !props?.isListItem &&
              (!!props?.vendorConfig?.nfc_hyperlinks ||
                !!props?.vendorConfig?.communication_hyperlinks) && (
                <NavLink
                  className={markAsActive(TABS.HYPERLINKS)}
                  onClick={() => setActiveTab(TABS.HYPERLINKS)}
                >
                  Hyperlinks
                </NavLink>
              )}
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={TABS.QUESTIONS} style={{ animation: "none" }}>
              <FormSection name={`${props.form}.questions`}>
                <Questions
                  feature={props.feature}
                  handleAddListItem={props.handleAddListItem}
                  isListItem={props.isListItem}
                  backButtonHandler={props.backButtonHandler}
                  design={props.design}
                />
              </FormSection>
            </TabPane>
            <TabPane tabId={TABS.RESPONSES} style={{ animation: "none" }}>
              <FormSection name={`${props.form}.responses`}>
                <Responses feature={props.feature} />
              </FormSection>
            </TabPane>
            {props?.isEventFeature &&
              !props?.isListItem &&
              (props?.vendorConfig?.nfc_hyperlinks ||
                props?.vendorConfig?.communication_hyperlinks) && (
                <TabPane tabId={TABS.HYPERLINKS} style={{ animation: "none" }}>
                  <MenuFeatureHyperlinks
                    event_id={props?.selectedEvent?.id}
                    menu_feature={props?.feature}
                  />
                </TabPane>
              )}
          </TabContent>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

Survey = reduxForm({
  form: FORM_NAMES.SURVEY,
  validate,
  initialValues: {
    survey_form: {
      questions: {
        includeResponses: true,
        questionsList: [
          {
            answerType: "1",
            answers: [
              { answer: "", id: null },
              { answer: "", id: null },
            ],
          },
        ],
      },
    },
  },
})(Survey)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorConfig: state.clients.vendorConfig,
})

Survey.propTypes = {
  feature: PropTypes.object,
  handleAddListItem: PropTypes.func,
  isListItem: PropTypes.bool,
  backButtonHandler: PropTypes.func,
}

export default connect(mapStateToProps)(Survey)
